import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Table, Alert, Spinner } from 'reactstrap';
import '../../../../_components/common/ModalNew2/index.css';

const AddParticipantsModal = ({ isOpen, toggle, onSubmit, response, isLoading, error, onSubmitComplete }) => {
    const [participants, setParticipants] = useState([{ email: '', name: '' }]);
    const [errors, setErrors] = useState([]);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [localIsLoading, setLocalIsLoading] = useState(false);
    const [hasSubmitted, setHasSubmitted] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            resetForm();
        }
    }, [isOpen]);

    useEffect(() => {
        if (hasSubmitted && !isLoading && (response || error)) {
            onSubmitComplete(response, error);
            toggle();
            setHasSubmitted(false);
        }
    }, [hasSubmitted, isLoading, response, error, onSubmitComplete, toggle]);

    const resetForm = () => {
        setParticipants([{ email: '', name: '' }]);
        setErrors([]);
        setIsSubmitDisabled(true);
        setLocalIsLoading(false);
        setHasSubmitted(false);
    };

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const list = [...participants];
        list[index][name] = value;
        setParticipants(list);
    };

    const handleAddClick = () => {
        setParticipants([...participants, { email: '', name: '' }]);
        setErrors([...errors, { email: '' }]);
    };

    const handleRemoveClick = (index) => {
        const list = [...participants];
        list.splice(index, 1);
        setParticipants(list);
        const newErrors = [...errors];
        newErrors.splice(index, 1);
        setErrors(newErrors);
    };

    const validateEmail = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = participants.map(participant => {
            const error = { email: '' };
            if (participant.email.trim() && !validateEmail(participant.email)) {
                error.email = 'Invalid email address';
                isValid = false;
            }
            return error;
        });
        setErrors(newErrors);
        return isValid;
    };

    useEffect(() => {
        const hasValidEmail = participants.some(participant => 
            participant.email.trim() !== '' && validateEmail(participant.email)
        );
        setIsSubmitDisabled(!hasValidEmail);
    }, [participants]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const validParticipants = participants.filter(p => p.email.trim() !== '' && validateEmail(p.email));
            setLocalIsLoading(true);
            setHasSubmitted(true);
            onSubmit(validParticipants);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle} className="bg-black text-white text-uppercase custom-header">Add Participants</ModalHeader>
            <ModalBody>
                {(isLoading || localIsLoading) && (
                    <div className="text-center mb-3">
                        <Spinner color="primary" />
                    </div>
                )}
                <Form onSubmit={handleSubmit}>
                    <Table>
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Name</th>
                                {participants.length > 1 && <th>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {participants.map((participant, index) => (
                                <tr key={index}>
                                    <td>
                                        <Input
                                            type="email"
                                            name="email"
                                            value={participant.email}
                                            onChange={(e) => handleInputChange(index, e)}
                                            placeholder="Enter email"
                                            invalid={!!(errors[index] && errors[index].email)}
                                            disabled={isLoading || localIsLoading}
                                        />
                                        {errors[index] && errors[index].email && <div className="text-danger small mt-1">{errors[index].email}</div>}
                                    </td>
                                    <td>
                                        <Input
                                            type="text"
                                            name="name"
                                            value={participant.name}
                                            onChange={(e) => handleInputChange(index, e)}
                                            placeholder="Enter name (optional)"
                                            disabled={isLoading || localIsLoading}
                                        />
                                    </td>
                                    {participants.length > 1 && (
                                        <td>
                                            <Button color="danger" onClick={() => handleRemoveClick(index)} disabled={isLoading || localIsLoading}>
                                                Remove
                                            </Button>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Button color="primary" onClick={handleAddClick} className="mt-2" disabled={isLoading || localIsLoading}>
                        Add More
                    </Button>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={isLoading || localIsLoading}>
                    Cancel
                </Button>
                <Button color="primary" onClick={handleSubmit} disabled={isSubmitDisabled || isLoading || localIsLoading}>
                    {(isLoading || localIsLoading) ? 'Submitting...' : 'Submit'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddParticipantsModal;


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/component/AddParticipantsModal.jsx